import { observer } from 'mobx-react-lite'

import { useStore } from '../../../../models'
import { events } from '../../../../models/analytics/analytics-events'
import { BaseButton } from './BaseButton'

export const NextButton = observer(() => {
  const {
    analytics: { setEvent },
    game: { goToNextStep, isFirstStep, step, isPreviousToLastStep, walkthroughType },
    session: { user }
  } = useStore()

  const handleNextStep = () => {
    if (walkthroughType === 'TableTour' && isPreviousToLastStep) {
      setEvent(events.homescreen.table_tour_finished, { userId: user?._id.toString() })
    }

    if (walkthroughType === 'RaiseOrFold') {
      if (isFirstStep) {
        setEvent(events.homescreen.raise_or_fold_started, { userId: user?._id.toString() })
      } else if (isPreviousToLastStep) {
        setEvent(events.homescreen.raise_or_fold_completed, { userId: user?._id.toString() })
      }
    }

    if (walkthroughType === 'DealTheFlop') {
      if (isFirstStep) {
        setEvent(events.homescreen.deal_the_flop_started, { userId: user?._id.toString() })
      }
    }

    goToNextStep()
  }

  //Step = 1, 2, 3 is table tour updated
  const text =
    step === 3 ? 'Start' : isFirstStep ? (walkthroughType === 'TableTour' ? 'Start Tour' : "Let's Play") : 'Next'
  return <BaseButton text={text} onPress={handleNextStep} />
})
